/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WarningTriangleIcon32Regular = forwardRef('WarningTriangleIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M17.249 21.5a1.248 1.248 0 1 1-2.497 0 1.248 1.248 0 0 1 2.497 0Z" }),
        React.createElement("path", { d: "M17 10.25a1 1 0 1 0-2 0v7.25a1 1 0 0 0 2 0v-7.25Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.582 3.93c1.558-2.563 5.278-2.563 6.836 0l10.329 16.992c1.62 2.666-.299 6.078-3.418 6.078H5.67c-3.12 0-5.038-3.412-3.418-6.078L12.582 3.93Zm5.127 1.039c-.779-1.282-2.639-1.282-3.418 0L3.962 21.96c-.81 1.333.15 3.039 1.71 3.039h20.657c1.56 0 2.519-1.706 1.709-3.039L17.709 4.97Z" })));
});
